"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    "1901": 9010,
    "1994": 9012,
    "1996": 9013,
    "1606nict": 9008,
    "1694acad": 9009,
    "1959acad": 9011,
    "abl1943": 9014,
    "akuapem": 9015,
    "alalc97": 9016,
    "aluku": 9017,
    "ao1990": 9018,
    "aranes": 9019,
    "arevela": 9020,
    "arevmda": 9021,
    "arkaika": 9022,
    "asante": 9023,
    "auvern": 9024,
    "baku1926": 9025,
    "balanka": 9026,
    "barla": 9027,
    "basiceng": 9028,
    "bauddha": 9029,
    "biscayan": 9030,
    "biske": 9031,
    "bohoric": 9032,
    "boont": 9033,
    "bornholm": 9034,
    "cisaup": 9035,
    "colb1945": 9036,
    "cornu": 9037,
    "creiss": 9038,
    "dajnko": 9039,
    "ekavsk": 9040,
    "emodeng": 9041,
    "fonipa": 9042,
    "fonkirsh": 9043,
    "fonnapa": 9044,
    "fonupa": 9045,
    "fonxsamp": 9046,
    "gallo": 9047,
    "gascon": 9048,
    "grclass": 9049,
    "grital": 9050,
    "grmistr": 9051,
    "hepburn": 9052,
    "heploc": 9053,
    "hognorsk": 9054,
    "hsistemo": 9055,
    "ijekavsk": 9056,
    "itihasa": 9057,
    "ivanchov": 9058,
    "jauer": 9059,
    "jyutping": 9060,
    "kkcor": 9061,
    "kociewie": 9062,
    "kscor": 9063,
    "laukika": 9064,
    "lemosin": 9065,
    "lengadoc": 9066,
    "lipaw": 9067,
    "ltg2007": 9068,
    "luna1918": 9069,
    "metelko": 9070,
    "monoton": 9071,
    "ndyuka": 9072,
    "nedis": 9073,
    "newfound": 9074,
    "nicard": 9075,
    "njiva": 9076,
    "nulik": 9077,
    "osojs": 9078,
    "oxendict": 9079,
    "pahawh2": 9080,
    "pahawh3": 9081,
    "pahawh4": 9082,
    "pamaka": 9083,
    "peano": 9084,
    "petr1708": 9085,
    "pinyin": 9086,
    "polyton": 9087,
    "provenc": 9088,
    "puter": 9089,
    "rigik": 9090,
    "rozaj": 9091,
    "rumgr": 9092,
    "scotland": 9093,
    "scouse": 9094,
    "simple": 9095,
    "solba": 9096,
    "sotav": 9097,
    "spanglis": 9098,
    "surmiran": 9099,
    "sursilv": 9100,
    "sutsilv": 9101,
    "synnejyl": 9102,
    "tarask": 9103,
    "tongyong": 9104,
    "tunumiit": 9105,
    "uccor": 9106,
    "ucrcor": 9107,
    "ulster": 9108,
    "unifon": 9109,
    "vaidika": 9110,
    "valencia": 9111,
    "vallader": 9112,
    "vecdruka": 9113,
    "vivaraup": 9114,
    "wadegile": 9115,
    "xsistemo": 9116
};
//# sourceMappingURL=variant.json.js.map